<template>
  <div class="w900">
    <div class="boardWrap">
      <board-filter @onSearch="onSearch"/>
      <div class="strTablescr">
        <div class="strTablePC">
          <table class="strTablePT">
            <thead>
              <tr>
                <th>{{$t('front.board.type')}}</th>
                <th>{{$t('front.board.title')}}</th>
                <th>{{$t('front.stributor.name')}}</th>
                <th>{{$t('front.board.regDate')}}</th>
              </tr>
            </thead>
            <tbody>
              <gibang-pinned-notice />
              <template v-for="item in list" v-bind:key="item.boardIdx">
                <tr>
                  <td>{{$t('front.boardCategory.' + item.category)}}</td>
                  <td>
                    <a href="#" @click.prevent="onClickRead(item.boardIdx)">
                      {{item.title}}
                      <span class="nsicon rdbg ml5">N</span>
                    </a>
                  </td>
                  <td>{{ item.memName }}</td>
                  <td>{{dateFormatAll(item.regDate)}}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
       <div class="mt20">
          <pagination
              :pageNum="pageInfo.page"
              :pageSize="pageInfo.count_per_list"
              :totalCount="pageInfo.tatal_list_count"
              @goToPage="loadList"
          />
       </div>
     </div>
  </div>
</template>

<script>
import Pagination from '@/components/ui/Pagination'
import BoardFilter from '@/components/common/BoardFilter'
import GibangPinnedNotice from '@/components/common/GibangPinnedNotice.vue'

export default {
  name: 'Notice',
  components: {
    GibangPinnedNotice,
    Pagination,
    BoardFilter
  },
  data () {
    return {
      list: null,
      boardType: 'nt',
      searchParam: {
        searchOption: '',
        searchValue: ''
      }
    }
  },
  created () {
    this.loadList()
  },
  methods: {
    onSearch (value) {
      this.searchParam.searchOption = value.type
      this.searchParam.searchValue = value.text

      this.loadList()
    },
    async loadList (page) {
      this.pageInfo.page = page || 1
      const params = {
        boardType: this.boardType
      }

      const searchValue = this.searchParam.searchValue
      if (searchValue) {
        params.searchOption = this.searchParam.searchOption
        params.searchValue = this.searchParam.searchValue
      }

      const result = await this.getBoardList(params, this.pageInfo.page)
      result.list.forEach(item => {
        item.isContentOpen = false
      })
      this.list = result.list
    },
    onClickRead (id) {
      if (!id) id = 1
      this.$router.push({ name: 'noticeRead', params: { boardIdx: id } })
    }
  }
}
</script>

<style scoped>
a{color:#121212;}
</style>
<style src="@/styles/striNew.css"></style>
<style scoped>
.applibtns{gap:20px;}
@media (max-width: 1000px) {
  .strTablePTM li {width: 100%;gap: 10px;}
  .ocmsg {margin: 0;}
}

/* 공지사항 목록 - 화이트 카드형 보정
   template/script 구조는 유지하고 검색/테이블 쉐입만 정리 */

.w900 {
  width: 100% !important;
  max-width: none !important;
  margin: 0 !important;
  padding: 24px 0 40px !important;
  box-sizing: border-box !important;
}

.boardWrap {
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  background: transparent !important;
  box-sizing: border-box !important;
}

/* BoardFilter 검색영역 */
.boardWrap :deep(.board-filter),
.boardWrap :deep(.boardFilter),
.boardWrap :deep(.boardFilterWrap),
.boardWrap :deep(.searchWrap),
.boardWrap :deep(.searchwrap),
.boardWrap :deep(.search-box),
.boardWrap :deep(.schWrap) {
  width: 100% !important;
  min-height: 54px !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  margin: 0 0 18px !important;
  padding: 0 !important;
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
}

/* BoardFilter가 별도 class 없이 렌더링되는 경우 대비 */
.boardWrap > :deep(div:first-child) {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  margin: 0 0 18px !important;
}

.boardWrap :deep(select),
.boardWrap :deep(input[type="text"]),
.boardWrap :deep(input[type="search"]) {
  height: 31px !important;
  padding: 0 12px !important;
  border: 1px solid #d4ddeb !important;
  border-radius: 6px !important;
  background: #ffffff !important;
  color: #263244 !important;
  font-size: 13px !important;
  line-height: 31px !important;
  outline: none !important;
  box-sizing: border-box !important;
  box-shadow: none !important;
}

.boardWrap :deep(select) {
  min-width: 118px !important;
  cursor: pointer !important;
}

.boardWrap :deep(input[type="text"]),
.boardWrap :deep(input[type="search"]) {
  min-width: 210px !important;
}

.boardWrap :deep(input:focus),
.boardWrap :deep(select:focus) {
  border-color: #5d8df6 !important;
  box-shadow: 0 0 0 3px rgba(93, 141, 246, 0.14) !important;
}

.boardWrap :deep(input::placeholder) {
  color: #8b97a8 !important;
}

.boardWrap :deep(.boardsearch button),
.boardWrap :deep(.searchBtn),
.boardWrap :deep(.btn-search) {
  min-width: 31px !important;
  height: 31px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 10px !important;
  border: 0 !important;
  border-radius: 7px !important;
  background: #5bb6b2 !important;
  color: #ffffff !important;
  font-size: 13px !important;
  font-weight: 800 !important;
  cursor: pointer !important;
  box-shadow: 0 5px 10px rgba(91, 182, 178, 0.16) !important;
  box-sizing: border-box !important;
}

.strTablescr {
  width: 100% !important;
  margin-top: 0 !important;
  padding: 0 !important;
  overflow: visible !important;
  background: transparent !important;
  border: 0 !important;
}

.strTablePC {
  width: 100% !important;
  overflow: hidden !important;
  border: 1px solid #dbe3ef !important;
  border-radius: 10px !important;
  background: #ffffff !important;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05) !important;
}

.strTablePT {
  width: 100% !important;
  border-collapse: collapse !important;
  table-layout: fixed !important;
  background: #ffffff !important;
  color: #1f2937 !important;
  font-size: 13px !important;
}

.strTablePT th,
.strTablePT td {
  height: 43px !important;
  padding: 9px 12px !important;
  border: 0 !important;
  border-bottom: 1px solid #dfe6ef !important;
  color: #1f2937 !important;
  text-align: center !important;
  vertical-align: middle !important;
  box-sizing: border-box !important;
}

.strTablePT th {
  height: 45px !important;
  background: #ffffff !important;
  color: #111827 !important;
  font-weight: 900 !important;
  border-bottom: 1px solid #cfd8e5 !important;
}

.strTablePC thead tr {
  border-top: 3px solid #2f6df6 !important;
}

.strTablePT tbody tr {
  background: #ffffff !important;
}

.strTablePT tbody tr:nth-child(2n) {
  background: #f5f5f6 !important;
}

.strTablePT tbody tr:hover {
  background: #eef6ff !important;
}

.strTablePT tbody tr:last-child td {
  border-bottom: 0 !important;
}

.strTablePT td:nth-child(2) {
  text-align: center !important;
}

.strTablePT td:nth-child(2) a {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 4px !important;
  max-width: 100% !important;
  color: #111827 !important;
  font-weight: 500 !important;
  text-decoration: none !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.strTablePT td:nth-child(2) a:hover {
  color: #2563eb !important;
}

.nsicon,
.rdbg {
  min-width: 15px !important;
  height: 15px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin-left: 4px !important;
  padding: 0 3px !important;
  border-radius: 2px !important;
  background: #ef233c !important;
  color: #ffffff !important;
  font-size: 10px !important;
  font-weight: 900 !important;
  line-height: 15px !important;
  box-sizing: border-box !important;
}

.mt20 {
  margin-top: 20px !important;
  display: flex !important;
  justify-content: center !important;
}

:deep(.partnerPaging),
:deep(.paging),
:deep(.pagination) {
  margin-top: 0 !important;
}

@media (max-width: 1000px) {
  .w900 {
    padding: 16px 0 30px !important;
  }

  .boardWrap > :deep(div:first-child),
  .boardWrap :deep(.board-filter),
  .boardWrap :deep(.boardFilter),
  .boardWrap :deep(.boardFilterWrap),
  .boardWrap :deep(.searchWrap),
  .boardWrap :deep(.searchwrap),
  .boardWrap :deep(.search-box),
  .boardWrap :deep(.schWrap) {
    flex-wrap: wrap !important;
    gap: 8px !important;
  }

  .boardWrap :deep(select),
  .boardWrap :deep(input[type="text"]),
  .boardWrap :deep(input[type="search"]) {
    flex: 1 1 calc(50% - 4px) !important;
    min-width: 0 !important;
  }

  .boardWrap :deep(.boardsearch button),
  .boardWrap :deep(.searchBtn),
  .boardWrap :deep(.btn-search) {
    flex: 0 0 36px !important;
  }

  .strTablePC {
    overflow-x: auto !important;
  }

  .strTablePT {
    min-width: 760px !important;
  }

  .strTablePTM li {
    width: 100% !important;
    gap: 10px !important;
  }

  .ocmsg {
    margin: 0 !important;
  }
}
</style>
